import { mapState } from "vuex";

let fromPath = null

const minin = {
  data() {
    return {
      fromPath: '',
      viewMode: false,
      labelWidth: '180px',
      form: {},
      formCtrl: [],
      formCtrl1: [],
      getOptionUrl: 'addpro',
      getDataUrl: 'item',
      submitUrl: 'addedu',
      mode: '',
      detail: {},
      id: '',
      rules: {
        inton: [
          { validator: this.checkTon, trigger: "blur" },
        ],
        unton: [
          { validator: this.checkTon, trigger: "blur" },
        ],
      },
      imgUrls: [],
      images: [],
      pdfjsLib: null,
      progress: 0,
      progressStatus: '',
      fileUploadType: 'contract',
    };
  },
  computed: {
    ...mapState([
      'user',
    ]),
  },
  methods: {
    // 设置了accept的控件不自动上传，在这里处理
    async onFileChange({
      key,
      value: {
        file,
        filelist
      }
    }) {
      console.log('onFileChange', key)
      console.log(file);
      // console.log({ ...file });
      // console.log(filelist);
      let max = 10
      if (this.formCtrl && this.formCtrl.length) {
        this.formCtrl.map(v => {
          if (v.keyName === key) {
            max = v.max
            // console.log({...v})
          }
        })
      }
      if (file && file.raw && file.raw.type) {
        // console.log(file.raw.type)
        if (file.raw.type === 'application/pdf') {
          // 每次读取前清空，否则会重复
          this.imgUrls = []
          // pdf
          const imgUrls = await this.readPDF(file, max)

          if (!this.form[key] || !this.form[key].length) {
            this.form[key] = []
          }

          if (imgUrls && imgUrls.length) {
            this.form[key].push(...imgUrls)
          }

          // console.log([...this.images])
          // console.log([...this.imgUrls])
          // console.log(this.imgUrls.length)

          // if (this.form[key] && this.form[key].length && this.imgUrls && this.imgUrls.length && (this.form[key].length + this.imgUrls.length < max)) {
          //   // console.log(max)
          //   this.form[key].push(...this.imgUrls)
          // } else {
          //   this.$set(this.form, key, this.imgUrls)
          // }
        } else {
          // 图片
          const base64str = await this.getBase64(file.raw)
          const f = await this.base64uploads(base64str)
          // console.log(f)
          if (this.form[key] && this.form[key].length) {
            this.form[key].push(...f)
          } else {
            this.$set(this.form, key, f)
          }
        }
      } else {
        console.log(filelist);
      }

      console.log(this.form[key])
      // console.log({ ...this.form })
    },

    // 加载 pdf.js
    async loadPdfJs() {
      try {
        // 使用 CDN 加载
        const script = document.createElement('script');
        script.src = 'https://cdnjs.cloudflare.com/ajax/libs/pdf.js/2.16.105/pdf.min.js';
        document.head.appendChild(script);

        // 等待加载完成
        await new Promise((resolve) => {
          script.onload = resolve;
        });

        // 设置 worker
        window.pdfjsLib.GlobalWorkerOptions.workerSrc =
          'https://cdnjs.cloudflare.com/ajax/libs/pdf.js/2.16.105/pdf.worker.min.js';

        this.pdfjsLib = window.pdfjsLib;
        console.log('pdf.js 加载成功');
      } catch (error) {
        console.error('加载 pdf.js 失败:', error);
        this.$message.error('PDF 解析库加载失败');
      }
    },

    async readPDF(file, max) {
      // 清除之前的图片
      this.images = [];

      // 验证文件类型
      if (file.raw.type !== 'application/pdf') {
        this.$message.error('请上传PDF文件');
        this.fileList = [];
        return;
      }

      // 验证文件大小（10MB）
      if (file.size > 10 * 1024 * 1024) {
        this.$message.error('文件大小不能超过10MB');
        this.fileList = [];
        return;
      }

      try {
        const arr = await this.convertPdfToImages(file.raw, max);

        // console.log(arr)

        return arr
      } catch (error) {
        console.error('转换失败:', error);
        this.$message.error('PDF转换失败，请检查文件是否损坏');
        this.fileList = [];
      }
    },

    // 转换 PDF 为图片
    async convertPdfToImages(pdfFile, max) {
      if (!this.pdfjsLib) {
        this.$message.error('PDF 解析库未加载');
        return;
      }

      this.loading = true;
      this.progress = 0;
      this.progressStatus = '';

      try {
        const arrayBuffer = await this.readFileAsArrayBuffer(pdfFile);

        // 使用加载的 pdfjsLib
        const loadingTask = this.pdfjsLib.getDocument({
          data: arrayBuffer,
          // 添加额外配置提高兼容性
          useSystemFonts: true,
          standardFontDataUrl: 'https://cdnjs.cloudflare.com/ajax/libs/pdf.js/2.16.105/standard_fonts/',
        });

        // console.log(loadingTask)

        const pdfDoc = await loadingTask.promise;

        // console.log(pdfDoc)

        // this.$message.success('PDF 转 Base64 成功')
        // ... 后续处理

        const totalPages = pdfDoc.numPages;

        // console.log(totalPages)

        // 检查页数限制（最多50页）
        if (totalPages > max) {
          this.$message.warning(`PDF页数超过${max}页，仅转换前${max}页`);
        }

        const maxPages = Math.min(totalPages, max);
        const images = [];

        const imgUrls = [];

        // 逐页转换
        for (let i = 1; i <= maxPages; i++) {
          const page = await pdfDoc.getPage(i);

          // 设置缩放比例（提高图片质量）
          const scale = 2.0;
          const viewport = page.getViewport({ scale });

          // 创建Canvas
          const canvas = document.createElement('canvas');
          const context = canvas.getContext('2d');
          canvas.width = viewport.width;
          canvas.height = viewport.height;

          // 渲染页面到Canvas
          const renderContext = {
            canvasContext: context,
            viewport: viewport,
          };

          await page.render(renderContext).promise;

          // 转换为图片数据
          const dataUrl = canvas.toDataURL('image/jpeg', 0.92);

          const f = await this.base64uploads(dataUrl)

          // console.log(f)

          if (this.imgUrls.length < max) {
            this.imgUrls.push(...f)

            imgUrls.push(...f)
          }

          // 生成文件名
          const fileName = `page_${String(i).padStart(3, '0')}.jpg`;

          images.push({
            pageNum: i,
            dataUrl: dataUrl,
            fileName: fileName,
            // 将dataURL转换为File对象（用于上传）
            file: this.dataURLtoFile(dataUrl, fileName),
          });

          // 更新进度
          this.progress = Math.round((i / maxPages) * 100);
          this.images = images; // 实时更新预览

        }
        
        this.progressStatus = 'success';
        // this.$message.success(`成功转换 ${images.length} 页图片`);
        
        this.loading = false

        return imgUrls;

      } catch (error) {
        this.loading = false
        console.error('转换错误:', error);
        this.$message.error('PDF 转换失败：' + error.message);
        throw error;
      }
    },

    // 读取文件为ArrayBuffer
    readFileAsArrayBuffer(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = (e) => resolve(e.target.result);
        reader.onerror = (e) => reject(e);
        reader.readAsArrayBuffer(file);
      });
    },

    // dataURL转换为File对象
    dataURLtoFile(dataUrl, fileName) {
      const arr = dataUrl.split(',');
      const mime = arr[0].match(/:(.*?);/)[1];
      const bstr = atob(arr[1]);
      let n = bstr.length;
      const u8arr = new Uint8Array(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      return new File([u8arr], fileName, { type: mime });
    },

    async base64uploads(f) {
      // console.log(obj)
      let url = `base/base64uploads`;
      const params = {
        // userid: this.user.id,
        type: this.fileUploadType,
        file: [f],
      }
      // console.log(params)
      const { data: { msg, file } } = await this.POST(url, params);
      if (msg === 'OK') {
        // this.$message({
        //   type: 'success',
        //   message: '提交成功!',
        // });
      } else {
        this.$message({
          type: 'error',
          message: msg,
        });
      }
      return file
    },

    // 读取文件为DataURL/获取文件的Base64
    getBase64(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file); // 开始读取

        reader.onload = () => {
          resolve(reader.result); // 读取成功，返回 result
        };

        reader.onerror = (error) => {
          reject(error); // 读取失败
        };
      });
    },

    // 检验是否超重
    checkTon(rule, value, callback) {
      // console.log(rule, value)
      // console.log(Number(value))
      // console.log(Number(value) > 60)
      // if (value == undefined || value == '') {
      //   callback(new Error('请确认密码'));
      // } else
      if (Number(value) > 3000) {
        callback(new Error('重量不能超过3000吨'));
      } else {
        callback();
      }
    },
    onChange({ key, value }) {
      // console.log(key, value)
      // console.log(Number(value))
      if (['identitycard', 'driverslicense', 'certificate', 'escortcard'].includes(key) || key.includes('photo') || (value && typeof value === 'object')) {
        const o = value.map(v => {
          let result = v
          if (v.response && v.response.photo) {
            result = { url: v.response.photo }
          }
          return result
        })
        this.$set(this.form, key, o)
        // } else if (['inton', 'unton'].includes(key) && Number(value) > 60) {
        // this.$message({
        //   type: 'error',
        //   message: '重量不能大于60吨',
        // });
        // return
      } else {
        this.$set(this.form, key, value)
      }
      // console.log('form', { ...this.form });
    },
    formOrtherValidate() {
      return true
    },
    onSubmit() {
      // console.log({ ...this.form });
      const boo = this.formOrtherValidate()
      // console.log(boo)
      const validate = this.$refs['form'].validate
      // MyForm组件验证
      const validatePass = this.$refs['form'].validatePass
      // console.log(this.$refs['form']);
      // console.log(validatePass);
      if (boo && validate) {
        validate((valid) => {
          // console.log(valid)
          if (valid) {
            this.submitConfirm()
          } else {
            console.log('验证不通过');
            console.log({ ...this.form })
            this.$message({
              type: 'error',
              message: '请修改错误信息',
            });
            return false;
          }
        });
      } else if (boo && validatePass) {
        validatePass(() => {
          this.submitConfirm()
        });
      }
    },
    submitConfirm() {
      this.$confirm('确认提交吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(this.submitReq).catch(() => { });
    },
    submitReq(data) {
      // console.log('data', data)
      if (this.loading) return
      this.loading = true
      let url = `${this.baseUrl}/${this.submitUrl}`;
      const params = {
        userid: this.user.id,
      }
      // 基础参数打包
      this.paramsPackage(params, this.form)
      // 特殊参数打包处理
      this.specialParamsPackage(params)
      if (typeof data === 'object') {
        for (const key in data) {
          if (Object.hasOwnProperty.call(data, key)) {
            params[key] = data[key];
          }
        }
      }
      if (this.id && this.mode === 'edit') {
        params['id'] = this.id
      }
      // console.log(url, params)
      this.post(url, params, ({ msg }) => {
        if (msg === 'success') {
          this.$message({
            type: 'success',
            message: '提交成功!',
          });
          this.$router.back()
        } else {
          this.$message({
            type: 'error',
            message: msg,
          });
        }
        this.loading = false
      }, err => {
        this.loading = false
        console.log(err)
        this.$message({
          type: 'error',
          message: '提交失败，请稍后重试！'
        });
      })
    },
    onCheckSubmit() {
      // console.log({ ...this.form });
      // console.log(this.$refs['form']);
      this.$refs['form'].validate((valid) => {
        const boo = this.formOrtherValidate()
        // console.log(valid, boo)
        if (valid && boo) {
          this.$confirm('确认审核通过吗？', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            this.checkSubmitReq({ isfleet: 2 })
          }).catch(() => { });
        } else {
          console.log('验证不通过');
          return false;
        }
      });
    },
    checkSubmitReq(data) {
      // console.log('data', data)
      if (this.loading) return
      this.loading = true
      let url = `${this.baseUrl}/${this.submitUrl}`;
      const params = {
        userid: this.user.id,
      }
      this.paramsPackage(params, this.form)
      if (typeof data === 'object') {
        for (const key in data) {
          if (Object.hasOwnProperty.call(data, key)) {
            params[key] = data[key];
          }
        }
      }
      if (this.id && this.mode === 'edit') {
        params['id'] = this.id
      }
      // console.log(url, params)
      this.post(url, params, ({ msg }) => {
        if (msg === 'success') {
          this.$message({
            type: 'success',
            message: '审核通过!',
          });
          this.$router.back()
        } else {
          this.$message({
            type: 'error',
            message: msg,
          });
        }
        this.loading = false
      }, err => {
        this.loading = false
        console.log(err)
        this.$message({
          type: 'error',
          message: '提交失败，请稍后重试！'
        });
      })
    },
    // 占位，特定页面中同名函数覆盖
    specialParamsPackage() { },
    paramsPackage(params) {
      const form = this.form
      const keys = [...(this.getKeys())]
      // console.log('keys', [...keys])
      for (const key in form) {
        if (
          Object.hasOwnProperty.call(form, key)
          && keys.includes(key)
        ) {
          // console.log(typeof form[key])
          const value = form[key]
          if (value && typeof value === 'object') {
            console.log(key, value)
            params[key] = value.map(v => {
              let result = v
              if (v.response && v.response.photo) {
                result = { url: v.response.photo }
              }
              return result
            })
          } else {
            params[key] = value;
          }
        }
      }
    },
    getKeys() {
      const formCtrl = [...this.formCtrl]
      const f1 = this.formCtrl1
      if (f1 && f1.length) {
        formCtrl.push(...f1)
      }
      const arr = formCtrl.map(v => v.keyName)
      return arr
    },
    cancel() {
      this.$router.back();
    },
    getDateParamsHandler(params) {
      return params
    },
    getData() {
      if (this.loading) return
      this.loading = true
      let url = `${this.baseUrl}/${this.getDataUrl}`;
      const params = {
        userid: this.user.id,
        id: this.id,
      }
      this.getDateParamsHandler(params)
      this.post(url, params, (res) => {
        const { msg, data } = res
        // console.log('res', { ...res })
        if (msg === 'success' && data) {
          this.detail = data
          // detail 对 form 进行赋值
          this.setDetail(res)
          // 获取 res 的其他数据进行处理
          this.setDetailOrderData(res)
        } else {
          this.$message({
            type: 'error',
            message: '加载失败，请稍后再试！',
          });
        }
        this.loading = false
      }, err => {
        console.log(err)
        this.$message({
          type: 'error',
          message: '获取数据失败，请稍后重试！'
        });
      })
    },
    setDetail() {
      if (this.detail) {
        this.form = { ...this.detail }
      }
      this.$forceUpdate()
      // console.log({ ...this.detail })
      console.log({ ...this.form })
    },
    setDetailOrderData() { },
    getOptions(params = {}) {
      this.post(`${this.baseUrl}/${this.getOptionUrl}`, {
        userid: this.user.id,
        ...params,
      }, this.setOptions, err => {
        console.log(err)
        this.$message({
          type: 'error',
          message: '获取数据失败，请稍后重试！'
        });
      })
    },
    setOptions() { },
  },
  beforeRouteEnter(to, from, next) {
    // console.log(from)
    fromPath = from.path
    next()
  },
  mounted() {
    // console.log(this.$route.query);
    const object = this.$route.query
    for (const key in object) {
      if (Object.hasOwnProperty.call(object, key)) {
        this[key] = object[key];
      }
    }
    const { id, mode } = object;
    // console.log(mode)
    if (id) {
      this.id = id
    }
    const b = this.breadcrumb
    this.mode = mode
    if (mode === 'view') {
      this.viewMode = true
      if (b && b[2]) {
        const n = b[2].name
        // console.log(n)
        if (n.includes('编辑')) {
          b[2].name = n.replace('编辑', '查看')
        } else {
          b[2].name = n.replace('添加', '查看')
        }
      }
    } else if (mode === 'edit') {
      if (b && b[2]) {
        const n = b[2].name
        // console.log(n)
        b[2].name = n.replace('添加', '编辑')
      } else if (b && b[1] && b[1].name.includes('添加')) {
        const n = b[1].name
        // console.log(n)
        b[1].name = n.replace('添加', '编辑')
      }
    }
    this.formCtrl.map(v => {
      const key = v.keyName
      this.$set(this.form, key, this.form[key] || undefined)
    })

    this.fromPath = fromPath
    // console.log('detial from path', this.fromPath)
    if (this.id) this.getData();
  },
}

export default minin